import React, { lazy, memo, Suspense } from 'react'
import { useSelector } from 'react-redux'
import { ConfigProvider } from 'antd'
import Loading from 'components/shared-components/Loading'
import { darkTheme, lightTheme } from 'configs/ThemeConfig'
import { resources } from 'lang'
import moment from 'moment'
import 'dayjs/locale/ko'
import 'dayjs/locale/en'
import 'dayjs/locale/zh'
import 'dayjs/locale/fr'
import 'dayjs/locale/ja'
import useBodyClass from 'utils/hooks/useBodyClass'
import Routes from 'routes'
import { useLocation } from 'react-router-dom'

const AppLayout = lazy(() => import('./AppLayout'))
const AuthLayout = lazy(() => import('./AuthLayout'))

const Layouts = () => {
  // ** Hooks
  const location = useLocation()

  const token = useSelector(state => state.auth.token)
  const blankLayout = useSelector(state => state.theme.blankLayout)

  const Layout = location.pathname.toLowerCase().startsWith('/erp')
    ? AuthLayout
    : token && !blankLayout
    ? AppLayout
    : AuthLayout

  const locale = useSelector(state => state.theme.locale)

  const direction = useSelector(state => state.theme.direction)

  const currentTheme = useSelector(state => state.theme.currentTheme)

  const currentAppLocale = resources[locale]

  useBodyClass(`dir-${direction}`)

  const themeConfig = currentTheme === 'light' ? { ...lightTheme } : { ...darkTheme }

  moment.locale(locale)

  return (
    <ConfigProvider theme={themeConfig} direction={direction} componentSize="small" locale={currentAppLocale.antd}>
      <Suspense fallback={<Loading cover="content" />}>
        <Layout>
          <Routes />
        </Layout>
      </Suspense>
    </ConfigProvider>
  )
}

export default memo(Layouts)
